module.exports = __webpack_public_path__ + "media/images/icons/cart-25feb88786598c354a128c055c1fcd5d.svg";